import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAssetWorkspacePath } from "@/features/jobs/lib/get-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getAssetWorkspacePath({
				orgId: params.orgId,
				jobId: params.jobId,
				assetId: params.assetId,
				tab: "form",
			}),
		});
	},
});
